import { isTouchEnabled } from '../../Theme';

export const ADD_PRODUCT_FADE_TRANSITION_DURATION = 500;

export const SHOW_TOPBAR_ADD_PRODUCT = false;

export const ORDER_OBJECT_TAB = {
  OVERVIEW: 'overview',
  ACTIVITIES: 'activities',
  TARGETS: 'targets',
  PRODUCTS: 'products',
  CONDITIONS: 'conditions',
} as const;

export const ORDER_PRODUCT_ROW_VERTICAL_SPACING = 8;

export const ORDER_PRODUCT_ROW_HEIGHT = {
  xs: 186,
  xsTouchGrid: 232,
  sm: 141,
  smCondensed: 141,
  smCondensedTouchGrid: 176,
  smTouchGrid: 187,
  md: 111,
  lg: isTouchEnabled ? 111 : 76,
  lgDesktopGrid: 76,
  lgTouchGrid: 102,
};

export const getBlackOverlay = (opacity: number) =>
  `linear-gradient(0deg, rgba(0, 0, 0, ${opacity}), rgba(0, 0, 0, ${opacity}))`;

export const ADD_PRODUCT_FIELD_OVERLAY = getBlackOverlay(0.08);

const THEME_SPACING_UNIT = 8;
const ADD_PRODUCT_ROW_BOTTOM_SPACING_PX = 6;

export const ADD_PRODUCT_ROW_BOTTOM_SPACING =
  ADD_PRODUCT_ROW_BOTTOM_SPACING_PX / THEME_SPACING_UNIT;

const ADD_PRODUCT_ROW_HEIGHT_SM = 150;

export const ADD_PRODUCT_ROW_RESERVED_SPACE = {
  xs: `${ORDER_PRODUCT_ROW_HEIGHT.xs + ADD_PRODUCT_ROW_BOTTOM_SPACING_PX}px`,
  sm: `${ADD_PRODUCT_ROW_HEIGHT_SM + ADD_PRODUCT_ROW_BOTTOM_SPACING_PX}px`,
  md: `${ORDER_PRODUCT_ROW_HEIGHT.md + ADD_PRODUCT_ROW_BOTTOM_SPACING_PX}px`,
  lg: `${ORDER_PRODUCT_ROW_HEIGHT.lg + ADD_PRODUCT_ROW_BOTTOM_SPACING_PX}px`,
};

export const ORDER_PRODUCT_ROW_BUTTON_SIZE = 28;
export const ADD_PRODUCT_ROW_FIELD_HEIGHT = 50;
